import { render, staticRenderFns } from "./popup_content_contact_form.vue?vue&type=template&id=778f5d1b&scoped=true&lang=pug"
import script from "./popup_content_contact_form.vue?vue&type=script&lang=js"
export * from "./popup_content_contact_form.vue?vue&type=script&lang=js"
import style0 from "../../assets/koromo_min.css?vue&type=style&index=0&id=778f5d1b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f5d1b",
  null
  
)

export default component.exports